import { Grid } from "@mui/material";

import { useMediaQuery } from "../../../hooks/useMediaQuery";

import { FullScreenDesktopImageDisplay } from "./FullScreenDesktopImageDisplay/FullScreenDesktopImageDisplay";
import { FullScreenMobileImageDisplay } from "./FullScreenMobileImageDisplay/FullScreenMobileImageDisplay";

interface FullScreenImageDisplayProps {
  photoUrls: string[];
  title: string;
  displayedImageIndex: number;
  isFullScreen: boolean;
  goLeft: () => void;
  goRight: () => void;
  closeFullScreen: () => void;
  setSelectedIndex: (index: number) => void;
}

const FullScreenImageDisplay: React.FC<FullScreenImageDisplayProps> = ({
  photoUrls,
  title,
  displayedImageIndex,
  isFullScreen,
  goLeft,
  goRight,
  closeFullScreen,
  setSelectedIndex,
}) => {
  const { isSmallScreen } = useMediaQuery();

  if (!isFullScreen) {
    return null;
  }

  return (
    <Grid item>
      {isSmallScreen ? (
        <FullScreenMobileImageDisplay
          title={title}
          goLeft={goLeft}
          goRight={goRight}
          photoUrls={photoUrls}
          onClose={closeFullScreen}
        />
      ) : (
        <FullScreenDesktopImageDisplay
          title={title}
          goLeft={goLeft}
          goRight={goRight}
          photoUrls={photoUrls}
          setSelectedIndex={setSelectedIndex}
          onClose={closeFullScreen}
          displayedImageIndex={displayedImageIndex}
        />
      )}
    </Grid>
  );
};

export default FullScreenImageDisplay;
